import { isDeveloperEmail } from '@feedyou/utils'
import { alert } from './bootbox'

export async function showHelp(email: string | undefined) {
  await alert({
    title: 'Keyboard shortcuts',
    message:
      '<table class="keyboard-shortcuts">' +
      '<tr><th><span>a</span></th><td>&emsp;<td><td>Collapse all dialogs</td></tr>' +
      '<tr><th><span>b</span></th><td>&emsp;<td><td>Select bot</td></tr>' +
      '<tr><th><span>t</span></th><td>&emsp;<td><td>Toggle try panel</td></tr>' +
      '<tr><th><span>d</span></th><td>&emsp;<td><td>Toggle dialogs panel</td></tr>' +
      '<tr><th><span>m</span></th><td>&emsp;<td><td>Toggle media panel</td></tr>' +
      '<tr><th><span>c</span></th><td>&emsp;<td><td>Toggle comments panel</td></tr>' +
      '<tr><th><span>h</span> or <span>v</span></th><td>&emsp;<td><td>Toggle versions panel</td></tr>' +
      '<tr><th><span>f</span> or <span>/</span></th><td>&emsp;<td><td>Search</td></tr>' +
      '<tr><th><span>s</span></th><td>&emsp;<td><td>Open bot settings</td></tr>' +
      '<tr><th><span>u</span></th><td>&emsp;<td><td>Scroll up</td></tr>' +
      '<tr><th><span>Tab</span></th><td>&emsp;<td><td>Next tab</td></tr>' +
      '<tr><th><span>Ctrl / <span>⌘</span></span> + <span>p</span></th><td>&emsp;<td><td>Preview bot</td></tr>' +
      '<tr><th><span>Ctrl / <span>⌘</span></span> + <span>s</span></th><td>&emsp;<td><td>Save bot</td></tr>' +
      '<tr><th><span>Ctrl / <span>⌘</span></span> + <span>d</span></th><td>&emsp;<td><td>Deploy bot</td></tr>' +
      '<tr><th><span>Ctrl / <span>⌘</span></span> + <span>Shift</span> + <span>s</span></th><td>&emsp;<td><td>Save & deploy bot</td></tr>' +
      getDeveloperToolsRow(email) +
      '</table>'
  })
}

function getDeveloperToolsRow(email: string | undefined) {
  if (!isDeveloperEmail(email)) {
    return ''
  }

  return '<tr><th><span>Ctrl / <span>⌘</span></span> + <span>Shift</span> + <span>Alt</span> + <span>d</span></th><td>&emsp;<td><td>Toggle developer tools popup</td></tr>'
}
